import { render, staticRenderFns } from "./dialogDetailProject.vue?vue&type=template&id=2e61dee4"
import script from "./dialogDetailProject.vue?vue&type=script&lang=js"
export * from "./dialogDetailProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports